import React from 'react';

export const defaultUploadContext: UploadContext = {
  uploads: {},
  setContext: () => null,
};

export default React.createContext<UploadContext>(defaultUploadContext);
